import styled from 'styled-components';
import { Link } from "react-router-dom";

export const Container = styled.div`
  width: 100%;
  padding-right: 15px;
  padding-left: 15px;
  margin-right: auto;
  margin-left: auto;

  @media (max-width: 576px) {
    padding-right: 5px;
    padding-left: 5px;
  }

  @media (min-width: 1200px) {
    max-width: 1140px;
  }

  @media (min-width: 768px) and (max-width: 1200px) {
    max-width: 720px;
  }

  @media (min-width: 576px) and (max-width: 768px) {
    max-width: 540px;
  }
`
export const WideContainer = styled.div`
  width: 100%;
  padding-right: 15px;
  padding-left: 15px;
  margin-right: auto;
  margin-left: auto;

  @media (max-width: 576px) {
    padding-right: 5px;
    padding-left: 5px;
  }

  @media (min-width: 768px) and (max-width: 1200px) {
    max-width: 720px;
  }

  @media (min-width: 576px) and (max-width: 768px) {
    max-width: 540px;
  }

  @media (min-width: 1200px) {
    max-width: 100%;
  }

  @media (min-width: 1300px) {
    max-width: 1240px;
  }
`

export const Row = styled.div`
    display: flex;
    flex-wrap: wrap;
    margin-right: -.5em;
    margin-left: -.5em;
`
export const Col = styled.div`
    position: relative;
    width: 100%;
    padding-right: .5em;
    padding-left: .5em;

    ${props => props.lg8 ? `
    @media (min-width: 992px) {
      flex: 0 0 66.666667%;
      max-width: 66.666667%;
    }
    ` : ""}
`
export const ColBr = styled(Col)`
  @media (min-width: 768px) {
      flex: 0 0 25%;
      max-width: 25%;
  }
  @media (min-width: 576px) and (max-width: 768px) {
      flex: 0 0 33.333333%;
      max-width: 33.333333%;
  }
`
export const Card = styled.div`
    position: relative;
    display: flex;
    flex-direction: column;
    min-width: 0;
    word-wrap: break-word;
    background-color: #fff;
    background-clip: border-box;
    border: 1px solid rgba(0,0,0,.125);
    border-radius: .25rem;
`
export const CardBody = styled.div`
    flex: 1 1 auto;
    min-height: 1px;
    padding: 1.25rem;
`
export const Pagination = styled.ul`
    display: flex;
    padding-left: 0;
    list-style: none;
    border-radius: .25rem;
    margin: .25rem;
`
export const PaginationItem = styled.li`
  ${props => props.dataDisabled ? `
    color: #6c757d;
    pointer-events: none;
    cursor: auto;
    background-color: #fff;
    border-color: #dee2e6;

    * {
      color: #6c757d;
    }
  ` : ''}
`
export const PageLink = styled.span`
    position: relative;
    display: block;
    padding: .5rem .75rem;
    margin-left: -1px;
    line-height: 1.25;
    color: #007bff;
    background-color: #fff;
    border: 1px solid #dee2e6;
    &:hover {
      z-index: 2;
      color: #0056b3;
      text-decoration: none;
      background-color: #e9ecef;
      border-color: #dee2e6;
    }
`
export const Breadcrumb = styled.ol`
    display: flex;
    flex-wrap: wrap;
    list-style: none;
    background-color: #f8f9fa;
    padding: 0.5rem 1rem;
    margin: 0.5rem 0;
    border-radius: 12px;
    box-shadow: 0 2px 8px rgba(139,125,101,0.07);
    align-items: center;
    min-height: 44px;
`;
export const BreadcrumbItem = styled.li`
    display: flex;
    align-items: center;
    font-size: 1.05rem;
    color: #8b7d65;
    font-weight: 500;
    padding: 0 0.5rem;
    border-radius: 8px;
    transition: background 0.15s, color 0.15s;
    a {
      color: #8b7d65;
      text-decoration: none;
      &:hover {
        color: #a08e6c;
        text-decoration: underline;
        background: #fffbe6;
        border-radius: 8px;
      }
    }
    &[aria-current='page'] {
      color: #fff;
      background: #8b7d65;
      font-weight: bold;
      cursor: default;
      a {
        color: #fff;
        pointer-events: none;
      }
    }
`;
export const BreadcrumbSeparator = styled.span`
    color: #b3a78e;
    margin: 0 0.25rem;
    font-size: 1.2em;
    user-select: none;
`
export const Input = styled.input`
  margin: 0;
  font-family: inherit;
  font-size: inherit;
  line-height: inherit;
`
export const InputGroup = styled.div`
  position: relative;
  display: flex;
  flex-wrap: wrap;
  align-items: stretch;
  width: 100%;
`
export const InputGroupPrepend = styled.div`
  margin-right: -1px;
`
export const Img = styled.img`
  max-width: 100%;
  height: auto;
`
export const Button = styled.button`
  display: inline-block;
  font-weight: 400;
  color: #212529;
  text-align: center;
  vertical-align: middle;
  cursor: pointer;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  background-color: transparent;
  border: 1px solid transparent;
  padding: .375rem .75rem;
  font-size: 1rem;
  line-height: 1.5;
  border-radius: .25rem;
  -webkit-transition: color .15s;
  transition: color .15s;
`
export const DropdownToggle = styled(Button)`
  white-space: nowrap;
  :empty:after {
    margin-left: 0;
  }
  :after {
    display: inline-block;
    margin-left: .255em;
    vertical-align: .255em;
    content: "";
    border-top: .3em solid;
    border-right: .3em solid transparent;
    border-bottom: 0;
    border-left: .3em solid transparent;
  }
`
const StyledLink = styled(Link)`
    text-decoration: none;
    text-decoration-style: unset;
    text-decoration-color: unset;
    cursor: pointer;
    color: #2d3e50;

    :hover {
      text-decoration: none;
      text-decoration-style: unset;
      text-decoration-color: unset;
      cursor: pointer;
    }
`
export {StyledLink as Link};

export const Wrapper = styled.div`
  .spinner {
    animation: spin infinite 5s linear;

    /*You can increase or decrease the timer (5s) to 
     increase or decrease the speed of the spinner*/
  }

  @keyframes spin {
    from {
      transform: rotate(0deg);
    }
    to {
      transform: rotate(360deg);
    }
  }

  .m-1 {
    margin: .25rem;
  }
  .ml-1 {
    margin-left: .25rem;
  }
  .mr-1 {
    margin-right: .25rem;
  }
  .mt-1 {
    margin-top: .25rem;
  }
  .mb-1 {
    margin-bottom: .25rem;
  }
  .m-2 {
    margin: .5rem;
  }
  .mb-2 {
    margin-bottom: .5rem;
  }
  .mt-2 {
    margin-top: .5rem;
  }
  .mt-3 {
    margin-top: 1rem;
  }
  .m-3 {
    margin: 1rem;
  }
  .mb-4 {
    margin-bottom: 1.5rem;
  }
  .m-4 {
    margin: 1.5rem;
  }
  .mt-5 {
    margin-top: 3rem; 
  }
  .mb-5 {
    margin-bottom: 3rem;
  }
  .m-5 {
    margin: 3rem;
  }
  .mt-a {
    margin-top: auto;
  }
  .mb-a {
    margin-bottom: auto;
  }
  .d-flex {
    display: flex;
  }
  .d-none {
    display: none;
  }
  .justify-content-center {
    justify-content: center;
  }
  .flex-column {
    flex-direction: column;
  }
  *, :after, :before {
    box-sizing: border-box;
  }
  .text-warning {
    color: #ffc107;
  }
  .border-0 {
    border: 0;
  }
  .bg-light {
    background-color: #f8f9fa;
  }
  .text-center {
    text-align: center;
  }
  .pb-2 {
    padding-bottom: .5rem;
  }
  .react-horizontal-scrolling-menu--scroll-container {
    display: flex;
    overflow: scroll;
  }

`
